import { render } from "./ViewContact.vue?vue&type=template&id=f9cf05ba&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import "./ViewContact.vue?vue&type=style&index=0&id=f9cf05ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9cf05ba"]])

export default __exports__